// extracted by mini-css-extract-plugin
module.exports = {"logos":"consulting-module--logos--3f2aF","logo":"consulting-module--logo--24uYd"};